<div class="flex items-center sm-w-100">
    <div [formGroup]="technicianGroup" class="grid grid-cols-3  sm-grid-cols-1 grill sm-w-100">
        <mat-form-field color="accent" class="formfield">
            <mat-label>Technician</mat-label>
            <mat-select (selectionChange)="setValue($event.value)" formControlName="technician" required>
                <mat-option *ngFor="let technician of technicians" [value]="technician">
                    {{technician.firstName}}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="technicianGroup.controls.technician.errors?.required">Please select technician</mat-error>
        </mat-form-field>
        <mat-form-field color="accent" class="formfield mx-12">
            <input matInput type="text" placeholder="Technician Email" [(ngModel)]="email"
                [ngModelOptions]="{standalone: true}" disabled>
        </mat-form-field>
        <mat-form-field color="accent" class="formfield">
            <input matInput type="text" placeholder="Technician Number" [(ngModel)]="phNo"
                [ngModelOptions]="{standalone: true}" disabled>
        </mat-form-field>
    </div>
    <mat-icon (click)="showUser()"><span class="material-symbols-outlined"> av_timerss </span></mat-icon>
</div>